export enum ImagesProperty {
  id = 'id',
  order_number = 'order_number',
  url = 'url',
}
